import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStartrekComponent } from './simple-icons-startrek.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStartrekComponent ],
    exports:      [ SimpleIconsStartrekComponent ],
    bootstrap:    []
})
export class SimpleIconsStartrekModule {}
